module.exports = __webpack_public_path__ + "img/Services.46819566.jpg";